import { ButtonHTMLAttributes } from 'react';

interface ButtonProps {
  type?: ButtonHTMLAttributes<HTMLButtonElement>['type'];
  disabled?: boolean;
  fullWidth?: boolean;
  isLoading?: boolean;
  children: React.ReactNode;
}

const Button = ({
  type = 'submit',
  disabled = false,
  fullWidth = true,
  isLoading = false,
  children,
}: ButtonProps) => {
  return (
    <button
      type={type}
      className={`btn btn-primary ${fullWidth && 'w-full'}`}
      disabled={disabled}
    >
      {isLoading && (
        <span className='loading loading-spinner loading-xs'></span>
      )}
      {children}
    </button>
  );
};

export default Button;
